// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ControlsTypes } from '../../../UtilsClasses/FactoryConstants';
import { ContainerControl } from '../../ContainerControl';
import PanelSideBarBaseNoDataPartial from '@front/templates/PanelSideBarBaseNoDataPartial.html';
export class PanelSideBarBase extends ContainerControl {
    constructor() {
        super();
        this.propertiesScreen = null;
    }
    oncomplete() {
        super.oncomplete();
        this.localize();
        void this.set('SideBarPanelRef', this);
    }
    getType() {
        return ControlsTypes.PanelSideBarBase;
    }
    isLostFocusForbidden() {
        return false;
    }
    isSettingsOpen() {
        return !isNullOrUndefined(this.propertiesScreen);
    }
    customLostFocus(parentPanel) {
        if (!isNullOrUndefined(this.propertiesScreen)) {
            this.propertiesScreen.on('teardown', () => {
                parentPanel.setFocus();
            });
            return true;
        }
        return false;
    }
    onMouseDown(event) {
        super.onMouseDown(event, false);
    }
    localize() { }
}
ContainerControl.extendWith(PanelSideBarBase, {
    data: function () {
        return {
            SideBarPanelRef: null,
            noDataText: '',
            noDataImg: ''
        };
    },
    partials: {
        noData: PanelSideBarBaseNoDataPartial
    }
});
